import { connect } from 'react-redux';
import { createSelector, createStructuredSelector } from 'reselect';
import FrameworkUtils from 'utils/framework';
import CreditCardsList from 'components/FrictionlessCheckout/PaymentReleaseFour/PaymentMethodList/CreditCardsList/CreditCardsList';
import { orderDetailsSelector } from 'selectors/order/orderDetails/orderDetailsSelector';
import OrderActions from 'actions/OrderActions';
import CheckoutActions from 'actions/CheckoutActions';
import LanguageLocaleUtils from 'utils/LanguageLocale';
import PaymentEN from 'components/FrictionlessCheckout/PaymentReleaseFour/locales/Payment_en_US';
import PaymentFR from 'components/FrictionlessCheckout/PaymentReleaseFour/locales/Payment_fr_CA';

const { wrapHOC } = FrameworkUtils;
const { getTextFromResource, getLocalisedDataFromResource } = LanguageLocaleUtils;
const getText = getLocalisedDataFromResource(PaymentEN, PaymentFR);

const localization = createStructuredSelector({
    removeCreditCard: getTextFromResource(getText, 'removeCreditCard'),
    areYouSureMessage: getTextFromResource(getText, 'areYouSureMessage'),
    remove: getTextFromResource(getText, 'remove'),
    cancel: getTextFromResource(getText, 'cancel'),
    expiredCreditCardMsg: getTextFromResource(getText, 'expiredCreditCardMsg'),
    edit: getTextFromResource(getText, 'edit'),
    gotIt: getTextFromResource(getText, 'gotIt'),
    cvc: getTextFromResource(getText, 'cvc'),
    moreInfoCvc: getTextFromResource(getText, 'moreInfoCvc'),
    useThisCard: getTextFromResource(getText, 'useThisCard'),
    showAll: getTextFromResource(getText, 'showAll'),
    showLess: getTextFromResource(getText, 'showLess'),
    ok: getTextFromResource(getText, 'ok'),
    deleteCard: getTextFromResource(getText, 'deleteCard')
});

const fields = createSelector(localization, orderDetailsSelector, (locales, orderDetails) => {
    return {
        locales,
        orderDetails
    };
});

const dispatchFunctions = {
    CreditCardListToggleCVC: CheckoutActions.CreditCardListToggleCVC,
    showCVCInfoModal: OrderActions.showCVCInfoModal
};

const withCreditCardsListProps = wrapHOC(connect(fields, dispatchFunctions));

export default withCreditCardsListProps(CreditCardsList);
